import React from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';

export const Error = () => {
  return (
    <div className="flex flex-col items-center mt-[75px]">
      <IconAlertTriangle />
      <p className="text-center mt-[10px] text-[12px]">
        We encountered an error. <br />
        Please refresh and try again
      </p>
    </div>
  );
};

export default Error;
